export default __webpack_public_path__ + "static/media/Vazir-Light.dac59184.ttf";